import { Form } from "antd";
import Modal from "antd/es/modal/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { onCreateItem, onUpdateSelectedItem } from "../../../redux/actions";
import ItemCreateForm from "./ItemCreateForm";

const CreateItem = (props) => {
  const dispatch = useDispatch();
  const {
    isAddItem,
    itemList,
    categoryList,
    handleAddItemClose,
    selectedItem,
    onSuccess,
    categorySearchPerPage,
  } = props;
  const [form] = Form.useForm();
  const [filePath, setFilePath] = useState("");

  useEffect(() => {
    form.resetFields();
  }, [selectedItem]);

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();

      if (selectedItem) {
        // Update existing item
        let i = 0;
        const length = values.attribute_info.length;
        const attribute_values = [];
        const attribute_ids = [];
        for (i; i < length; i++) {
          attribute_values.push(values.attribute_info[i].attribute_value);
          attribute_ids.push(values.attribute_info[i].attribute_id);
        }
        const updateObj = {
          id: selectedItem.id,
          image_path: filePath,
          name: selectedItem.name,
          status: selectedItem.status,
          attribute_id: attribute_ids,
          attribute_value: attribute_values,
          ...values,
          item_type_id: values.item_type_id || null,
        };

        // Wait for the update to complete
        await dispatch(onUpdateSelectedItem(updateObj));
      } else {
        // Create new item
        let i = 0;
        const length = values.attribute_info.length;
        const attribute_values = [];
        const attribute_ids = [];
        for (i; i < length; i++) {
          attribute_values.push(values.attribute_info[i].attribute_value);
          attribute_ids.push(values.attribute_info[i].attribute_id);
        }
        const newItem = {
          image_path: filePath,
          status: values.status,
          attribute_id: attribute_ids,
          attribute_value: attribute_values,
          ...values,
          item_type_id: values.item_type_id || null,
        };

        // Wait for the creation to complete
        await dispatch(onCreateItem(newItem));
        form.setFieldsValue({ name: "" });
      }

      // Reset form and close modal
      form.resetFields();
      handleAddItemClose();

      // Trigger refresh after operation completes
      if (props.refetch) {
        props.refetch();
      }

      if (onSuccess) {
        onSuccess();
      }
    } catch (info) {
      console.log("Validate Failed:", info);
    }
  };

  return (
    <>
      <Modal
        forceRender
        open={isAddItem}
        title={selectedItem ? `Update Item` : "Create Item"}
        okText={"Save"}
        cancelText="Discard"
        cancelButtonProps={{ type: "danger" }}
        onCancel={() => {
          handleAddItemClose();
          form.resetFields();
        }}
        onOk={handleModalOk}
      >
        <Form
          form={form}
          preserve={false}
          layout="vertical"
          name="form_in_modal"
          initialValues={{
            attribute_info: selectedItem?.attribute_value_info,
            file: selectedItem?.image_path || "",
            status: selectedItem?.status || "1",
            category_id: selectedItem?.category_id || "",
            name: selectedItem?.name || "",
            item_type_id: selectedItem?.item_type_id || null,
          }}
        >
          <ItemCreateForm
            setFilePath={setFilePath}
            selectedItem={selectedItem}
            itemList={categoryList}
            form={form}
            categorySearchPerPage={categorySearchPerPage}
          />
        </Form>
      </Modal>
    </>
  );
};

export default CreateItem;
